function buildMenu (allowed) {
  let menu = []
  if (allowed == null || allowed.includes('Sensors') || allowed.includes('Automation') || allowed.includes('Sidekick'))  {
    menu = [
    {
      title: 'Sensors',
      icon: 'mdi-gauge',
      items: [
        {
          title: 'Dashboard', 
          icon: 'mdi-thermometer-lines',
          path: '/DshSensors'
        }
      ]
    }
  ] } 
  return menu
}

export default buildMenu